import React from "react";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#a71307",
      light: "#f06666",
    },
    secondary: {
      main: "#fff",
      light: "#ebebeb"
    }
  },
  typography: {
    h5: {
      fontSize: "25px",
    },
  },
});

export default theme;
